import { SimpleSecurity } from '../security.domain';
import { RelatedAccount } from '../account.domain';

export enum EventType {
  EARNINGS = 'EARNINGS',
  DIVIDENDS = 'DIVIDENDS',
  RATING_CHANGES = 'RATING_CHANGES',
  NEWS = 'NEWS'
}

export interface MarketReport {
  dateTime: Date;
  docKey: string;
  link: string;
  name: string;
  reportType: string;
  url: string;
}

export interface NewsReport extends BaseMarketEvent {
  docKey: string;
  docSource: string;
  headline: string;
  link: string;
  reportDatetime: Date;
  retrievedTimestamp: Date;
  marketNewsType: 'CanadaNews' | 'USNews' | 'MTAfterHours' | 'MTAfterHours'; // not used on the frontend
  source: string;
  text: string;
  url: string;
}

export interface MarketIndicator {
  security: string;
  market: string;
  open: number;
  high: number;
  last: number;
  change: number;
  percent: number;
  time: Date;
  title: string;
  marketName: string;
  description: string;
}

export interface MarketOutlookResponse {
  marketOutlook: MarketOutlook;
}

export interface MarketOutlook {
  marketReports?:  Array<MarketReport>;
  newsReports?: Array<NewsReport>;
  marketIndicators?: Array<MarketIndicator>;
}

export interface BaseMarketEvent {
  security: SimpleSecurity;
  retrievedTimestamp: Date;
  securityEventType: EventType;
}

export interface NewsContent {
  readonly storyId: string;
  readonly headline: string;
  readonly source: string;
  readonly text: string;
  readonly dateTime: Date;
}

export interface SecurityNewsResponse {
  id: string;
  news: Array<NewsReport>;
  securities: Array<SimpleSecurity>;
}

// TODO: this is a duplication. there is an interface Dividend defined in quote domain
export interface Dividends extends BaseMarketEvent {
  exDate: Date;
  paymentDate: Date;
  comments: string;
  dividendPerShare: number;
  annualizedDividend: number;
  relatedAccounts?: Array<RelatedAccount>;
}

export interface Earnings extends BaseMarketEvent {
  date: Date;
  estimate: number;
  actual?: number;
  numAnalysts: number;
  period: string;
  previousYear: number;
  revenue: string; // abbreviated value - e.g. 359.4M
}

export interface RatingsChange extends BaseMarketEvent {
  eventDate: Date;
  brokerageReporting: string;
  currentRating: string;
  previousRating?: string; // TODO: Remove this field when switch is removed for newAnalystRatings
  priceTarget: number;
  analystName?: string; // TODO: Remove optional when switch is removed for newAnalystRatings
  analystRanking?: number; // TODO: Remove optional when switch is removed for newAnalystRatings
  totalAnalystRanking?: number; // TODO: Remove optional when switch is removed for newAnalystRatings
}

export type MarketEvent = Dividends | Earnings | RatingsChange;

export class EventsData {
  events: Events;
  dateRange: EventsDateRange;
}

export type Events = Pick<EventsResponse, 'dividends' | 'earnings' | 'ratingsChange'>;
export type EventsDateRange = Pick<EventsResponse, 'fromDate' | 'toDate'>;
export type EventProperty = keyof Events;

export interface EventGroup<T extends MarketEvent> {
  eventType: EventType;
  dateRange: EventsDateRange;
  events: Array<T>;
}

export interface EventsResponse {
  id: string;
  fromDate: Date;
  toDate: Date;
  dividends?: Array<Dividends>;
  earnings?: Array<Earnings>;
  ratingsChange?: Array<RatingsChange>;
}
